import type { Listing } from '@thevillages/schemas';

import { Component, computed, inject, input, output, signal } from '@angular/core';

import { ComputedListingOpenNow } from '../../../computed-values';
import { SaveService } from '../../../services/save/save';
import { StateService } from '../../../services/state/state';
import { HomeListingCardFeatures } from '../../listing-card/home/features/features';
import { Slideshow } from '../../slideshow/slideshow';
import { ListingDetailsActions } from '../actions/actions';
import { ListingDetailsFeaturesDetails } from '../features-details/features-details';
import { ListingDetailsFeatures } from '../features/features';
import { ListingDetailsInfo } from '../info/info';
import { ListingDetailsOpenHouse } from '../open-house/open-house';
import { ListingDetailsSeriesDetails } from '../series-details/series-details';
import { ListingDetailsVillageDetails } from '../village-details/village-details';
import { Download } from './download';
import { Images } from './images';

@Component({
  imports: [
    HomeListingCardFeatures,
    ListingDetailsActions,
    ListingDetailsFeatures,
    ListingDetailsFeaturesDetails,
    ListingDetailsInfo,
    ListingDetailsOpenHouse,
    ListingDetailsSeriesDetails,
    ListingDetailsVillageDetails,
    Slideshow,
  ],
  selector: 'app-home-listing-details',
  styleUrl: './home.css',
  templateUrl: './home.html',
})
export class HomeListingDetails {
  protected readonly saveService = inject(SaveService);
  protected readonly stateService = inject(StateService);

  public readonly listing = input.required<Listing>();
  public readonly openGalleryClicked = output<number>();
  public readonly openMapClicked = output();
  public readonly openTourClicked = output();

  public readonly selectedImage = signal<number>(1);

  protected readonly download = computed(() => Download.call(this));
  protected readonly images = computed(() => Images.call(this));
  protected readonly openNow = computed(() => ComputedListingOpenNow(this.listing()));

  protected openDownload(): void {
    // This can only be called if the value is set so we do not need to check if it exists.
    window.open(this.download(), '_blank');
  }
}
